import { ConcreteEncodable } from "./ConcreteEncodable";

import { TradingChannelProfileImplEncoder } from "../../encoder/TradingChannelProfileImplEncoder";

import * as CubiqTS from "../../index";
import { TradingChannelProfile } from "../TradingChannelProfile";

export class TradingChannelProfileImpl extends ConcreteEncodable implements TradingChannelProfile {
  public static enType: string = "com.bcdfx.model.TradingChannelProfileImpl";

  /*FID=2*/
  public tradingSourceDisplayName: string;
  /*FID=3*/
  public isAutoRouteToSI: boolean;
  /*FID=4*/
  public isSupportsAccountAliasFg: boolean;
  /*FID=6*/
  public isQueueBackedChannelFg: boolean;
  /*FID=7*/
  public modificationsAllowed: CubiqTS.Long | null = null;
  /*FID=8*/
  public cancellationAllowed: CubiqTS.Long | null = null;
  /*FID=9*/
  public isMarkupAllowedFg: boolean;
  /*FID=10*/
  public minUsdEquivTradingAmount: CubiqTS.BigNumber | null = null;
  /*FID=11*/
  public isCreditApprovalEnabledFg: boolean;
  /*FID=12*/
  public diTimeoutSecs: CubiqTS.Long | null = null;
  /*FID=13*/
  public tiTimeoutSecs: CubiqTS.Long | null = null;
  /*FID=14*/
  public isSupportsUserAliasFg: boolean;
  /*FID=15*/
  public validateBranchGoodUntilFg: boolean;
  /*FID=16*/
  public channelId: string;
  /*FID=17*/
  public groupTradingChannelId: string;
  /*FID=18*/
  public creditApprovalAction: CubiqTS.Long | null = null;
  /*FID=19*/
  public preNettingEnabledFg: boolean;
  /*FID=100*/
  public messageId: string;

  constructor() {
    super();
    this.encoder = TradingChannelProfileImplEncoder.Instance;
    this.setEncodableType(TradingChannelProfileImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "TradingChannelProfileImpl[" +
      "tradingSourceDisplayName=" +
      this.tradingSourceDisplayName +
      "isAutoRouteToSI=" +
      this.isAutoRouteToSI +
      "isSupportsAccountAliasFg=" +
      this.isSupportsAccountAliasFg +
      "isQueueBackedChannelFg=" +
      this.isQueueBackedChannelFg +
      "modificationsAllowed=" +
      this.modificationsAllowed +
      "cancellationAllowed=" +
      this.cancellationAllowed +
      "isMarkupAllowedFg=" +
      this.isMarkupAllowedFg +
      "minUsdEquivTradingAmount=" +
      this.minUsdEquivTradingAmount +
      "isCreditApprovalEnabledFg=" +
      this.isCreditApprovalEnabledFg +
      "diTimeoutSecs=" +
      this.diTimeoutSecs +
      "tiTimeoutSecs=" +
      this.tiTimeoutSecs +
      "isSupportsUserAliasFg=" +
      this.isSupportsUserAliasFg +
      "validateBranchGoodUntilFg=" +
      this.validateBranchGoodUntilFg +
      "channelId=" +
      this.channelId +
      "groupTradingChannelId=" +
      this.groupTradingChannelId +
      "creditApprovalAction=" +
      this.creditApprovalAction +
      "preNettingEnabledFg=" +
      this.preNettingEnabledFg +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
